import { render, staticRenderFns } from "./PgaNumberField.vue?vue&type=template&id=33d7ca2d&"
import script from "./PgaNumberField.vue?vue&type=script&lang=ts&"
export * from "./PgaNumberField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d7ca2d')) {
      api.createRecord('33d7ca2d', component.options)
    } else {
      api.reload('33d7ca2d', component.options)
    }
    module.hot.accept("./PgaNumberField.vue?vue&type=template&id=33d7ca2d&", function () {
      api.rerender('33d7ca2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/PgaNumberField.vue"
export default component.exports